import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=5aec7a55&scoped=true&"
import script from "./FloatingButton.vue?vue&type=script&lang=js&"
export * from "./FloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=5aec7a55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec7a55",
  null
  
)

export default component.exports